<template>
  <div class="avecor-table" style="background:#ccc !important;"> 
    <!-- TABLE --->
    <v-data-table
      :headers="headers"
      :items="ordersArray"
      hide-default-footer
      disable-pagination
      class="avecor-ordered-products-table"
      style="overflow:scroll;height:420px;background:#eee;"
    >
      <template v-slot:item="props">
        <!-- < style="height:25px;" class="hide-field-details"> -->
        <tr>
          <!--<td class="text-xs-left">{{ props.item.number }}</td>-->
          <td style="max-width:30px">
            <v-icon style=""
              v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'"
              :size="settings.tableSelectIconsSize"
              @click="deleteItem(props.item)"
            >
              far fa-trash-alt
            </v-icon>
          </td>
          <td style="max-width:30px">
            <v-text-field
                slot="input"
                :value="customFormatter(props.item.created_at.seconds * 1000)"
                label="Edit"
                class="avecor-select"
                single-line
                disabled
            ></v-text-field>
          </td>
          <td class="text-xs-left">
            <v-autocomplete
                :value="props.item.salesperson"
                :items="getSalespersons"
                disabled
                persistent-hint
                item-text="text"
                item-value="id"
                hide-details
                dense
                class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
              />
          </td>
          <td class="text-xs-left">
            <v-text-field
                :value="props.item.netvisorId"
                class="avecor-select"
                disabled/>
          </td>
          <td>
            <v-textarea
                :value="props.item.summary"
                class="avecor-select"
                :auto-grow="true"
                rows=1
                disabled/>
          </td>
          <td>
            <v-textarea
                :value="props.item.orderComments"
                class="avecor-select"
                rows=1
                :auto-grow="true"
                disabled/>
          </td>
          <td class="maxw-100">
            <v-autocomplete
              :value="props.item.contactId"
              :items="getCompaniesAndContacts"
              label=""
              rows=1
              placeholder="  "
              item-text="text"
              item-value="value"
              @change="inlineSaveNewContactAndCompany($event,props.item)"
              chips
              class="avecor-select"
            >
              <template v-slot:selection="data">
                <v-chip
                  :input-value="data.selected"
                  small
                  solo
                  class="chip--select-multi"
                  
                >
                  {{ data.item.text.substr(0,50) }}
                </v-chip>
              </template>
            </v-autocomplete>
          </td>
        </tr>
      </template>
      <template slot="no-data">
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
var db = null
import firebase from 'firebase'

export default {
    props: ['companyId'],
    data: () => ({
      ordersArray:[],
      autogrow: true,
      headers: [
        { text: '', value: '', align: 'left', sortable: true},  
        { text: 'Tilauksen pvm.', value: 'addedDate', align: 'left', sortable: true},
        { text: 'Myyjä', value: 'salesperson', align: 'left', sortable: true},
        { text: 'Netvisor Id', value: 'firstName', align: 'left', sortable: true},
        { text: 'Tilauskooste', value: 'lastName', align: 'left', sortable: true},
        { text: 'Myyjän kommentit', value: 'phone', align: 'left', sortable: true},
        { text: 'Yritys+Kontakti', value: 'companyId', align: 'left', sortable: true},
      ],
    }),
    mounted() {
      db = firebase.firestore();
      this.getOrders()
    },
    computed: {
      getCompaniesAndContacts(){
        var list = []
        Object.keys(this.contacts).forEach(key =>{
          var c = this.contacts[key]
          //if (companies[c.companyId] === undefined) console.log(c)
          if(this.companies[c.companyId] === undefined) {}//console.log(c.companyId)}
          else {
            var text = this.companies[c.companyId].companyName+' - '+c.firstName+' '+c.lastName
            list.push({text, value: c.id})
          }
        })
        return list
      },
      formTitle () {
        return this.editedIndex === -1 ? 'Lisää asiakas' : 'Muokkaa tuotetta'
      },
      getSalespersons(){
        var staff = this.staff
        var salespersons = []
        Object.keys(this.staff).forEach(key => {
          var s = staff[key]
          if(s.role === 'sales' || s.role === 'ceo' || s.id ==='RqjgIwdXWzXqCR2MOVr1etp2iY22') salespersons.push({text:s.firstName, id:s.id})
          if(this.user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' && key === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1') salespersons.push({text:s.firstName, id:s.id})
        })
        return salespersons
      },
      ...mapFields({
        user:"user",
        staff:"staff.staff",
        products:"product.products",
        productVariations:"productVariation.productVariations",
        contacts:"contact.contacts",
        orders:"order.orders",
        orderedProducts:"orderedProduct.orderedProducts",
        companies:"company.companies",
        settings:"settings",
        samplesArray:"newOrderDetails.samplesArray",
        deliveryCharges:"newOrderDetails.deliveryCharges",
        positioningCharges:"newOrderDetails.positioningCharges"
      }),
      
    },
    watch: {
      companyId:function (val) {
        console.log(val)
        this.getOrders()
      },
    },
    created () {},
    methods: {
      async deleteItem(order){
        try{
          console.log(order)
          if (confirm('Haluatko varmasti poistaa tilauksen?')) {
            await db.collection('orders').doc(order.id).delete()
            console.log(order.id)
            for(const opId of Object.keys(order.ops)){
              console.log(opId)
              await db.collection('orderedProducts').doc(opId).delete()
            }
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Poistettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            this.getOrders()
          }
        }
        catch(e){
          console.log(e)
        }
      },
      async getOrders(){
        let t = this
        this.ordersArray = []
        var companyId = this.companyId
        var orders = {}
        const snapshot = await db.collection("orders").where('companyId', '==', companyId).get()
        for(var i = 0; i < snapshot.docs.length;i++){
          var doc = snapshot.docs[i]
          var data = doc.data()
          orders[doc.id] = data
          orders[doc.id].summary = ""
        }

        for(const oId of Object.keys(orders)){
          const snapshot = await db.collection("orderedProducts").where('orderId', '==', oId).get()
          orders[oId].ops = {}
          for(var i = 0; i < snapshot.docs.length;i++){
            var doc = snapshot.docs[i]
            var data = doc.data()
            orders[oId].ops[doc.id] = data
          }
        }
        
        var returnOrders = []

        Object.keys(orders).forEach(oId => {
          console.log(orders[oId])
          Object.keys(orders[oId].ops).forEach(opId => {
            console.log({opId})
            const op = orders[oId].ops[opId]
            const productId = op.productId
            var pv = t.productVariations[op.productVariationId]

            orders[oId].summary += t.products[productId] !== undefined ? t.products[productId].name.fi : ''
            if(pv && pv.colorCode){
              var colorName = ""
              if(t.settings.colors[pv.colorCode]) colorName = t.settings.colors[pv.colorCode].fi
              orders[oId].summary += '-'+colorName
            }
            if(pv && pv.size && pv.size.trim() !== ""){ orders[oId].summary += '-'+pv.size}   
            orders[oId].summary += ' ➔  ' + op.quantity + '  x  ' + op.unitPrice +'€ '+'\n'
          })
          returnOrders.push(orders[oId])
        })

        returnOrders = returnOrders.sort(function(a,b){
          var aDate = a.created_at.seconds
          var bDate = b.created_at.seconds
          return bDate - aDate;
        });

        this.ordersArray = returnOrders

      },
      getOrders_OLD(){
        var id = this.companyId
        var obj = {}
        var oIds = []
        Object.keys(this.orders).forEach(oId => {
          var o = this.orders[oId]
          if(o.companyId === id) {
            oIds.push(o.id)
            obj[oId] = JSON.parse(JSON.stringify(o))
            obj[oId].summary = ''
          }
        })
        
        Object.keys(this.orderedProducts).forEach(opId => {
          var op = this.orderedProducts[opId]
          var pv = this.productVariations[op.productVariationId]
          if(op.orderId && op.orderId.length > 5 && oIds.includes(op.orderId)){
            obj[op.orderId].summary === undefined ? obj[op.orderId].summary = '' : ''
            obj[op.orderId].summary += ''
            obj[op.orderId].summary += this.products[op.productId] !== undefined ? this.products[op.productId].name.fi : ''
            if(pv && pv.colorCode){
              var colorName = ""
              if(this.settings.colors[pv.colorCode]) colorName = this.settings.colors[pv.colorCode].fi
              obj[op.orderId].summary += '-'+colorName
            }
            if(pv.size && pv.size.trim() !== ""){obj[op.orderId].summary += '-'+pv.size}   
            obj[op.orderId].summary += ' ➔  ' + op.quantity + '  x  ' + op.unitPrice +'€ '+'\n'
          }
        })
        
        var a = []
        Object.keys(obj).forEach(oId =>{
          a.push(obj[oId])
        })
        this.ordersArray = a
      },
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
        
        //moment(date).format('MMMM Do YYYY, h:mm:ss a');
      },
      inlineSaveNewContactAndCompany(contactId,order){
        var orderId = order.id
        var companyId = this.contacts[contactId].companyId
        console.log({companyId, contactId})
        
        
        /*
        var oldCompanyId = this.orders[orderId].companyId
        var oldContactId = this.orders[orderId].contactId
        var oldCompanyTotalOrders = this.companies[oldCompanyId].totalOrders
        var newCompanyTotalOrders = this.companies[companyId].totalOrders */

        if (contactId && companyId && orderId) {
          console.log({contactId,companyId,orderId})
          db.collection('orders').doc(orderId).set({ 
            companyId,
            contactId
          }, { merge: true })
          .then(function() {
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          })
          this.getOrders()
          
        }
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/CompanyOrdersTable.vue